import { render } from "./CoachFilter.vue?vue&type=template&id=12171afe"
import script from "./CoachFilter.vue?vue&type=script&lang=js"
export * from "./CoachFilter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\THULIB\\Documents\\GitHub\\Coach-Finder-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__